import {PlusOutlined} from '@ant-design/icons';
import {Badge, Button, Form, Input} from 'antd';
import React, {FC, useState} from 'react';

import {EComparisonType} from 'components/form/hooks/use-form-watcher/use-form-watcher-constants';

import {requiredInputRule, numberWithDotRule, numberLengthValidationRule} from '../../utils';
import {GoalIndicatorsItem} from './goal-indicators-item';
import {ProductionIndicatorsItem} from './production-indicators-item';

export const TargetIndicators: FC = () => {
    const [isInvestProjectTargetsListOpen, setIsInvestProjectTargetsListOpen] = useState<boolean>(true);
    const [isProductionTargetsListOpen, setIsInvestProjectTargetListOpen] = useState<boolean>(true);

    const handleInvestProjectTargetsListOpener = () => {
        setIsInvestProjectTargetsListOpen(!isInvestProjectTargetsListOpen);
    }

    const handleProductionTargetsListOpener = () => {
        setIsInvestProjectTargetListOpen(!isProductionTargetsListOpen);
    }

    return (
        <div className="form-flex">
            <div className="form-flex-row">
                <Form.Item
                    name={['targetIndicators', 'workplacesCount']}
                    label="Количество создаваемых рабочих мест"
                    rules={[
                        numberLengthValidationRule({comparisonOperator: EComparisonType.LESS, value: 10000})
                    ]}
                >
                    <Input type="number" placeholder="Введите значение" autoComplete="off"/>
                </Form.Item>
                <Form.Item
                    name={['targetIndicators', 'increasedRevenue']}
                    label="Увеличение выручки в рублях (по результатам реализации проекта)"
                >
                    <Input type="number" placeholder="Введите значение" autoComplete="off"/>
                </Form.Item>
                <Form.Item
                    name={['targetIndicators', 'increasedRevenuePercentage']}
                    label="Увеличение выручки в % (по результатам реализации проекта)"
                    rules={[
                        requiredInputRule(),
                        numberWithDotRule({valueBefore: 3, valueAfter: 2}),
                    ]}
                >
                    <Input type="number" placeholder="Введите значение" autoComplete="off"/>
                </Form.Item>
            </div>
            <div className="form-flex-row">
                <div
                    className="form-flex"
                    style={{
                        maxHeight: 'calc(min(600px, 64vh))',
                        overflow: 'auto',
                        paddingRight: 8,
                        width: '100%',
                    }}
                >
                    <Form.List name={['targetIndicators', 'productionIndicators']}>
                        {(fields, {add, remove}) => (
                            <>
                                <Badge
                                    count={!isProductionTargetsListOpen ? fields.length : undefined}
                                    className="text-project-badge add-project-badge"
                                >
                                    <Button
                                        type="text"
                                        className="text-button"
                                        onClick={handleProductionTargetsListOpener}
                                    >
                                        <h4>Целевые показатели производства продукции</h4>
                                    </Button>
                                </Badge>
                                {isProductionTargetsListOpen && (
                                    <>
                                        <Badge count={fields.length} className="add-project-badge">
                                            <Button
                                                type="primary"
                                                onClick={() => add()}
                                                icon={<PlusOutlined/>}
                                                className="add-project-button"
                                            >
                                                Добавить Показатель
                                            </Button>
                                        </Badge>

                                        {fields.map((field) => (
                                            <ProductionIndicatorsItem
                                                key={field.key}
                                                field={field}
                                                onRemove={remove}
                                            />
                                        ))}
                                    </>
                                )}
                            </>
                        )}
                    </Form.List>
                </div>
            </div>
            <div className="form-flex-row">
                <div
                    className="form-flex"
                    style={{
                        maxHeight: 'calc(min(600px, 64vh))',
                        overflow: 'auto',
                        paddingRight: 8,
                        width: '100%',
                    }}
                >
                    <Form.List name={['targetIndicators', 'goalIndicators']}>
                        {(fields, {add, remove}) => (
                            <>
                                <Badge
                                    count={!isInvestProjectTargetsListOpen ? fields.length : undefined}
                                    className="text-project-badge add-project-badge"
                                >
                                    <Button
                                        type="text"
                                        className="text-button"
                                        onClick={handleInvestProjectTargetsListOpener}
                                    >
                                        <h4>Целевые основные показатели инвестиционного проекта</h4>
                                    </Button>
                                </Badge>
                                {isInvestProjectTargetsListOpen && (
                                    <>
                                        <Badge count={fields.length} className="add-project-badge">
                                            <Button
                                                type="primary"
                                                onClick={() => add()}
                                                icon={<PlusOutlined/>}
                                                className="add-project-button"
                                            >
                                                Добавить Показатель
                                            </Button>
                                        </Badge>

                                        {fields.map((field) => (
                                            <GoalIndicatorsItem
                                                key={field.key}
                                                field={field}
                                                onRemove={remove}
                                            />
                                        ))}
                                    </>
                                )}
                            </>
                        )}
                    </Form.List>
                </div>
            </div>
        </div>
    )
};


